'use strict';

wbApp.controller('ActivitiesCtrl', ['$scope', '$modal', '$timeout', '$q', '$translate', '$filter', 'activitySvc', 'semesterSvc', 
    'classroomSvc', 'accountingBookSvc', 'protectedStorageSvc', 'securitySvc',
    function ($scope, $modal, $timeout, $q, $translate, $filter, activitySvc, semesterSvc, 
              classroomSvc, accountingBookSvc, protectedStorageSvc, securitySvc) {

        $scope.isSaving = false;
        $scope.protectedStorageEdit = securitySvc.isInRole('ProtectedStorage.Insert');

        $scope.filterOptions = {
            filterText: ""
        };

        $q.all([semesterSvc.getDefaultAsync(),
            accountingBookSvc.getDefaultAsync(),
            classroomSvc.getAllAsync().$promise,
            accountingBookSvc.getAllAsync().$promise])
            .then(function (data) {
                if (data[0]) {
                    $scope.semesterID = data[0].id;
                }

                if (data[1]) {
                    $scope.defaultAccountingBookID = data[1].id;
                }

                $scope.activities = activitySvc.getAllBySemesterIDAsync(
                    $scope.semesterID != null ? $scope.semesterID : null);
            });

        $scope.onSemesterChange = function (semesterID) {
            refreshData(false);
        }

        function refreshData(reselect) {
            return $q(function (resolve, reject) {
                var selectedRowKeys = null;
                if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                    selectedRowKeys = $scope.gridSettings.gridInstance.getSelectedRowKeys();
                }

                var all = activitySvc.getAllBySemesterIDAsync($scope.semesterID, true);
                all.$promise.then(function (data) {
                    $scope.activities = data;

                    if (!!selectedRowKeys && !!$scope.gridSettings && !!$scope.gridSettings.gridInstance && !!reselect) {
                        $timeout(function () {
                            $scope.gridSettings.gridInstance.selectRows(selectedRowKeys, false).then(function (rows) {
                                if (!rows || !rows.length) {
                                    setSelectedActivity(null);
                                }
                            })
                        }, 100);
                    } else {
                        setSelectedActivity(null);
                    }

                    resolve();

                }, function (error) {
                    $scope.activities = [];
                    setSelectedActivity(null);

                    reject();
                });
            });
        }

        function setSelectedActivity(activity, refresh) {
            $scope.selectedActivity = activity;
            $scope.$broadcast('activitySelectionChanged', $scope.selectedActivity);
        }

        $scope.$on('refreshData', function (e, data) {
            refreshData(true);
        });

        $scope.gridSettings = {
            name: 'activities',
            columns: [
                {
                    dataField: 'name',
                    caption: $translate.instant('TXT_LBL_NAME'),
                    dataType: 'string',
                    width: '170px',
                    sortOrder: 'asc'
                },
                {dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string'},
                {
                    dataField: 'classroomID',
                    caption: $translate.instant('TXT_LBL_CLASSROOM'),
                    dataType: 'string',
                    calculateCellValue: function (rowData) {
                        return $filter('classroom')(rowData.classroomID);
                    },
                    width: '250px'
                },
            ]
        }

        $scope.onRowSelected = function (data) {
            setSelectedActivity(data);
        }

        $scope.onRowAdd = function () {

            $scope.activityDetail = {
                semesterID: $scope.semesterID,
                isNew: true,
                accountingBookID: $scope.defaultAccountingBookID,
            };
            $scope.activityDetailOrig = angular.copy($scope.activityDetail);

            detailDialogPromise.$promise.then(function () {
                $scope.detailError = null;
                detailDialogPromise.show();
            });
        }

        $scope.onRowEdit = function (data) {

            var promises = [];
            var modelPromise = activitySvc.getByActivityID(data.activityID, true);
            promises.push(modelPromise.$promise);

            promises.push(detailDialogPromise.$promise);

            $q.all(promises).then(function () {
                $scope.activityDetail = modelPromise;
                $scope.activityDetailOrig = angular.copy($scope.activityDetail);

                detailDialogPromise.show();
            });
        }

        $scope.onRowDelete = function (data) {
            activitySvc.remove(data).$promise.then(function () {
                refreshData(false);
            });
        }

        $scope.onActivityDetailSave = function (data) {

            if ($scope.isSaving) {
                return;
            }

            $scope.isSaving = true;

            if (data.isNew) {
                activitySvc.insert(data, success, error);
            } else {
                activitySvc.update(data, success, error);
            }

            function success() {
                detailDialogPromise.hide();
                $scope.isSaving = false;
                refreshData(true);
            }

            function error(errorResult) {
                $scope.detailError = errorResult;
                $scope.isSaving = false;
            }
        }

        $scope.detailIsUnchanged = function (data) {
            return angular.equals(data, $scope.activityDetailOrig);
        }

        $scope.tabs = [
            {
                title: 'TXT_DETAIL',
                template: "activities/detail-tabs/home.html",
            }
        ];

        $scope.tabs.activeTab = 0;

        $scope.detailTabs = [
            {
                title: 'TXT_MAIN',
                template: "activities/activities-detail-main-tab.html"
            }, {
                title: 'TXT_PRICE_TAB',
                template: "activities/activities-detail-price-tab.html"
            }, {
                title: 'TXT_LBL_COMPENSATIONS',
                template: "activities/activities-detail-compensation-tab.html"
            }, {
                title: "TXT_LBL_DESCRIPTION",
                template: "activities/activities-detail-description-tab.html"
            }, {
                title: 'TXT_LBL_PHOTO_ALBUM',
                template: "activities/activities-detail-storage-tab.html"
            }];

        $scope.detailTabs.activeTab = 0;

        $scope.$watch('detailTabs.activeTab', function (newValue, oldValue) {
            switch (newValue) {
                case 4:
                    loadGalleryInfo();
                    break;
            }
        });
        
        $scope.galleryInfoBusy = false;
        $scope.galleryInfoData = [];
        function loadGalleryInfo() {
            if (!$scope.activityDetail.picturesFolders || $scope.activityDetail.picturesFolders.length === 0) {
                return;
            }
            
            $scope.galleryInfoBusy = true;
            protectedStorageSvc.findGalleryInfoByPaths($scope.activityDetail.picturesFolders, false)
                .$promise.then(function(data) {
                        $scope.galleryInfoBusy = false;
    
                        $scope.galleryInfoData = _.keyBy(data, function(o) {
                            return o.galleryDirectoryPath;
                        });
                    }, 
                    function (error) {
                        $scope.galleryInfoBusy = false;
                    }
                );
            
        }

        var detailDialogPromise = $modal({
            templateUrl: 'activities/activities-detail.html',
            show: false,
            scope: $scope
        });

        var protectedStorageSelectDlgPromise = $modal({
            templateUrl: 'storage/protected-storage/protected-storage-select-dlg.html',
            show: false,
            scope: $scope.$new()
        });

        var galleryInfoEditDlgPromise = $modal({
            templateUrl: 'activities/gallery-info-edit-dlg.html',
            show: false,
            scope: $scope.$new()
        });

        $scope.showProtectedStorageSelect = function () {
            protectedStorageSelectDlgPromise.$promise.then(function () {

                protectedStorageSelectDlgPromise.$scope.selectFoldersOnly = true;

                protectedStorageSelectDlgPromise.$scope.onFilesSelected = function (files) {

                    if (!$scope.activityDetail.picturesFolders) {
                        $scope.activityDetail.picturesFolders = [];
                    }

                    angular.forEach(files, function (p) {
                        if (!$scope.activityDetail.picturesFolders.find(e => e == p.objectUri)) {
                            $scope.activityDetail.picturesFolders.push(p.objectUri);
                            loadGalleryInfo();
                        }
                    });
                };
                protectedStorageSelectDlgPromise.show();
            });
        }

        $scope.removePicture = function (pictureUrl) {
            const index = $scope.activityDetail.picturesFolders.indexOf(pictureUrl);
            if (index > -1) {
                $scope.activityDetail.picturesFolders.splice(index, 1);
            }
        }
        
        $scope.startEditInfo = function(galleryDirectory) {
            let model = $scope.galleryInfoData[galleryDirectory];
            galleryInfoEditDlgPromise.$promise.then(function () {
                galleryInfoEditDlgPromise.$scope.model = angular.copy(model);
                galleryInfoEditDlgPromise.$scope.galleryDirectory = galleryDirectory;
                galleryInfoEditDlgPromise.$scope.onGalleryInfoSave = function (newModel) {
                   // $scope.galleryInfoData[galleryDirectory] = newModel;
                    loadGalleryInfo();
                }
                galleryInfoEditDlgPromise.show();
            });
        }

    }]);